import { FamilyService } from './../../services/family/family.service';
import { Router } from '@angular/router';
import { PdvService } from '@app/services/pdv/pdv.service';
import { Component, ElementRef } from '@angular/core';
import { OrdersService } from '@app/services/order/orders.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { Subscription } from 'rxjs';
@Component({
    selector: 'home',
    templateUrl: 'home.component.html',
    styleUrls: ['home.component.scss']
})
export class HomeComponent {
    displayBestSales: boolean;
    displayBestOffers: boolean;
    authorizedCities: any[] = [];
    families: any[] = [];
    ourAppEvent;
    newsletters: any = {
        "prenom": "",
        "email": ""
    };
    pdv: any = {};
    loader = false;
    bsModalRef: BsModalRef;
    modalRef: BsModalRef;
    subscriptions: Subscription[] = [];
    enablePayement = false;
    subs: Subscription;
    orderTypes: any[] = [];
    constructor(private pdvService: PdvService,
        private router: Router,
        private familyService: FamilyService,
        private orderService: OrdersService,
        private modalService: BsModalService
    ) {
        this.orderService.ourAppEvent.subscribe(
            (data) => {
                this.ourAppEvent = data;
            }
        )
        const subs2 = this.pdvService.pdv.subscribe(
            pdv => {
                this.pdv = pdv;
            }
        );
        const subs1 = this.pdvService.orderTypes.subscribe((orderTypes: any[]) => {
            this.orderTypes = orderTypes;
        });
        this.getFamiliesOfCarte();
    }

    ngOnDestroy() {
        this.subs.unsubscribe();
    }

    ngOnInit() {
        this.pdvService.pdv.subscribe(
            (pdv: any) => {
                if (pdv) {
                    this.displayBestSales = pdv.displayBestSales;
                }
            }
        )
        this.pdvService.getAuthorizedCities().subscribe(
            (authorizedCities: any[]) => {
                this.authorizedCities = authorizedCities;
            }
        )
        this.subs = this.orderService.enablePayement.subscribe(
            (enablePayement) => {
                this.enablePayement = enablePayement
            }
        );
    }
    goToModes(id) {
        this.orderService.chosenOrderType.next(id);
        this.router.navigate(['modes'])
    }
    getFamiliesOfCarte() {
        this.familyService.families.subscribe(
            (families: any[]) => {
                this.families = families.map(m => {
                    m.label = m.label.toLowerCase();
                    return m
                })
            }
        )
    }
    selectFam(family) {
        this.router.navigate(['/carte/famille/' + family.slug]);
        this.modalRef.hide();
    }
    openModalFam(template: ElementRef) {
        this.subscriptions.push(
            this.modalService.onHidden.subscribe(() => {
                this.unsubscribe();
            })
        );
        this.modalRef = this.modalService.show(template, { class: 'fam-modal' });
    }
    goToCarte() {
        if (this.displayBestSales) {
            this.router.navigate(['/carte/top-des-ventes'])
        } else {

            this.router.navigate(['/carte/famille/' + this.families[0].slug])
        }
    }
    unsubscribe() {
        this.subscriptions.forEach((subscription: Subscription) => {
            subscription.unsubscribe();
        });
        this.subscriptions = [];
    }

    goToMenus() {
        this.router.navigate(['/carte/menus']);
    }
}
